import React, { useMemo } from 'react';
import { FaqUi } from '../ui';
import { useTranslation } from 'react-i18next';
import { SimpleTeaser } from 'cpfr-common';

export const FaqPublic: React.FC<{ faqTeaser?: SimpleTeaser }> = ({ faqTeaser }) => {
    const { t } = useTranslation('faq-cms');

    const content = useMemo(() => {
        const items: { question: string; answer: string }[] = t('content.public.items', {
            returnObjects: true,
            defaultValue: [],
        });

        return {
            header: t('content.public.header'),
            items: items.filter((item) => !!item.question && !!item.answer),
        };
    }, [t]);

    return <FaqUi faqTeaser={faqTeaser} faqContent={content} />;
};
